import { QueryClient } from '@tanstack/react-query';

// Exported at module level (not created inline in main.tsx) so non-component code can reset the
// cache — needed later for sign-out and for the demo/preview mode.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});
